import { Component, ViewChild, OnDestroy, AfterViewInit, Inject } from '@angular/core';
import { MDC_DIALOG_DATA, MdcDialogRef } from '@angular-mdc/web';
import { FormControl, Validators } from '@angular/forms';
import { ContentService } from 'src/app/content.service';
import QrScanner from 'qr-scanner';
QrScanner.WORKER_PATH = '/assets/qr-scanner-worker.min.js';

// Feilkoder fra backend
const FB_ERRORS: { [key: number]: string } = {
  2: 'Koden finnes ikke',
  3: 'Ugyldig kodeformat',
  4: 'Koden er invalidert',
  5: 'Koden er allerede brukt',
  6: 'Fribilletter er ikke tillatt for denne forestillingen'
};

@Component({
  selector: 'app-fribillett-betaling',
  templateUrl: './fribillett-betaling.component.html',
  styleUrls: ['./fribillett-betaling.component.scss']
})
export class FribillettBetalingComponent implements OnDestroy, AfterViewInit {

  @ViewChild('scanVideoElm', { static: true }) private scanVideoElm;
  private qrScanner;

  public kodeinput = new FormControl('', [Validators.required, Validators.minLength(10)]);

  feilmelding: string = '';
  detaljertFeil: string = '';
  pending = false;
  validertKode: string = null;
  fribillettId: number = null;
  fribillettNummer: string = null;

  constructor(
    private dialogRef: MdcDialogRef<FribillettBetalingComponent>,
    private contentService: ContentService,
    @Inject(MDC_DIALOG_DATA) private data: any
  ) {
    this.kodeinput.valueChanges.subscribe(() => {
      this.feilmelding = '';
      this.detaljertFeil = '';
      this.validertKode = null;
    });
    if (!this.data?.forestilling_id) console.warn('Mangler forestilling_id');
  }

  ngAfterViewInit() {
    this.qrScanner = new QrScanner(this.scanVideoElm.nativeElement, this.kodeScanned.bind(this));
    this.qrScanner.start();
  }

  ngOnDestroy() {
    if (this.qrScanner) {
      this.qrScanner.stop();
    }
  }

  kodeScanned(kode: string) {
    if (kode) {
      this.qrScanner.stop();
      this.kodeinput.setValue(kode);
      this.verifiser();
    }
  }

  verifiser() {
    if (this.pending) return;
    this.feilmelding = '';
    this.detaljertFeil = '';
    this.validertKode = null;

    const kode = this.kodeinput.value.trim().toUpperCase();

    // Sjekk at koden ser ut som en fribillett-kode (starter med FRI)
    if (!kode.startsWith('FRI')) {
      this.feilmelding = 'Koden må starte med FRI';
      return;
    }

    this.pending = true;
    this.contentService.fetchContent(`/salg/fribillett_verify/${kode}/${this.data.forestilling_id}`).subscribe(
      res => {
        this.pending = false;
        if (res.code === 1) {
          // Koden er gyldig
          this.validertKode = kode;
          this.fribillettId = res.fribillett_id;
          this.fribillettNummer = res.fribillett_nummer;
        } else {
          this.feilmelding = FB_ERRORS[res.code] || 'Ukjent feil';
          if (res.detaljer) {
            this.detaljertFeil = res.detaljer;
          }
        }
      },
      err => {
        this.pending = false;
        this.feilmelding = 'Teknisk feil – prøv igjen';
        console.error('Fribillett verify error:', err);
      }
    );
  }

  brukFribillett() {
    if (!this.validertKode) return;
    this.dialogRef.close({
      fb_kode: this.validertKode,
      fribillett_id: this.fribillettId,
      fribillett_nummer: this.fribillettNummer
    });
  }

}
